import { useApplicationStore } from '../../../model/store'

// Перечень допустимых текстов плана оплаты для каждого года.
const FIRST_YEAR_ALLOWED = ['Помесячный', 'Квартальный', 'Погодичный']
const OTHER_YEAR_ALLOWED = ['Семестровый', 'Квартальный', 'Погодичный']

export function usePaymentTypeFilter(paymentTypeIdByKind, mode) {
  const store = useApplicationStore()

  const findText = (id) => store.paymentTypes.find(item => item.value === id)?.text

  const filteredPaymentTypes = (kind) => {
    if (mode.value === 'pending') return store.paymentTypes

    if (kind === 'first_year') {
      let options = store.paymentTypes.filter(item => FIRST_YEAR_ALLOWED.includes(item.text))
      const otherYearText = findText(paymentTypeIdByKind.value.other)
      if (otherYearText && otherYearText !== 'Семестровый') {
        options = options.filter(item => item.text !== 'Помесячный')
      }
      return options
    }

    let options = store.paymentTypes.filter(item => OTHER_YEAR_ALLOWED.includes(item.text))
    const firstYearText = findText(paymentTypeIdByKind.value.first_year)
    if (firstYearText && firstYearText !== 'Помесячный') {
      options = options.filter(item => item.text !== 'Семестровый')
    }
    return options
  }

  const setPaymentType = (kind, paymentTypeId) => {
    paymentTypeIdByKind.value[kind] = paymentTypeId

    const relatedKind = kind === 'first_year' ? 'other' : 'first_year'
    const relatedPaymentTypeId = paymentTypeIdByKind.value[relatedKind]
    if (!filteredPaymentTypes(relatedKind).some(item => item.value === relatedPaymentTypeId)) {
      paymentTypeIdByKind.value[relatedKind] = null
    }
  }

  return { filteredPaymentTypes, setPaymentType }
}
